import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const OneEightFourToTwoOneThree = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>184</Td>
          <Td>เอษรา 1,2</Td>
          <Td>ลูกา 2</Td>
          <Td>Ezra 1,2</Td>
          <Td>Luke 2</Td>

          <Td>วันที่ยิ่งใหญ่เหนือวันใดๆ</Td>
        </tr>
        <tr>
          <Td>185</Td>
          <Td>เอษรา 3,4</Td>
          <Td>ลูกา 3</Td>
          <Td>Ezra 3,4</Td>
          <Td>Luke 3</Td>

          <Td>ทำงานอย่างมีเป้าหมาย</Td>
        </tr>
        <tr>
          <Td>186</Td>
          <Td>เอษรา 5,6</Td>
          <Td>สดุดี 77</Td>
          <Td>Ezra 5,6</Td>
          <Td>Psalms 77</Td>

          <Td>ข้ออ้างอิงที่ไม่ผิดพลาด</Td>
        </tr>
        <tr>
          <Td>187</Td>
          <Td>เอษรา 7,8</Td>
          <Td>ลูกา 4</Td>
          <Td>Ezra 7,8</Td>
          <Td>Luke 4</Td>

          <Td>ถูกเลือกให้เป็นผู้นำ</Td>
        </tr>
        <tr>
          <Td>188</Td>
          <Td>เอษรา 9,10</Td>
          <Td>ลูกา 5</Td>
          <Td>Ezra 9,10</Td>
          <Td>Luke 5</Td>

          <Td>หมอมีไว้สำหรับคนป่วย</Td>
        </tr>
        <tr>
          <Td>189</Td>
          <Td>เนหะมีย์ 1,2</Td>
          <Td>สดุดี 78:1-37</Td>
          <Td>Nehamiah 1,2</Td>
          <Td>Psalms 78:1-37</Td>

          <Td>เฝ้าดูและระวัง</Td>
        </tr>
        <tr>
          <Td>190</Td>
          <Td>เนหะมีย์ 3,4</Td>
          <Td>ลูกา 6</Td>
          <Td>Nehamiah 3,4</Td>
          <Td>Luke 6</Td>

          <Td>งานดำเนินต่อไป</Td>
        </tr>
        <tr>
          <Td>191</Td>
          <Td>เนหะมีย์ 5,6</Td>
          <Td>ลูกา 7</Td>
          <Td>Nehamiah 5,6</Td>
          <Td>Luke 7</Td>

          <Td>ด้วยสิทธิอำนาจ</Td>
        </tr>
        <tr>
          <Td>192</Td>
          <Td>เนหะมีย์ 7,8</Td>
          <Td>ลูกา 8</Td>
          <Td>Nehamiah 7,8</Td>
          <Td>Luke 8</Td>

          <Td>คนหูหนวกได้ยิน</Td>
        </tr>
        <tr>
          <Td>193</Td>
          <Td>เนหะมีย์ 9,10</Td>
          <Td>สดุดี 78:38-72</Td>
          <Td>Nehamiah 9,10</Td>
          <Td>Psalms 78:38-72</Td>

          <Td>พร้อมที่จะถูกทดสอบ</Td>
        </tr>
        <tr>
          <Td>194</Td>
          <Td>เนหะมีย์ 11,12</Td>
          <Td>ลูกา 9</Td>
          <Td>Nehamiah 11,12</Td>
          <Td>Luke 9</Td>

          <Td>พลเมืองของอาณาจักรใหม่</Td>
        </tr>
        <tr>
          <Td>195</Td>
          <Td>เนหะมีย์ 13</Td>
          <Td>ลูกา 10</Td>
          <Td>Nehamiah 13</Td>
          <Td>Luke 10</Td>

          <Td>ยุทธวิธีของการปฏิรูป</Td>
        </tr>
        <tr>
          <Td>196</Td>
          <Td>เอสเธอร์ 1-3</Td>
          <Td>สดุดี 79</Td>
          <Td>Esther 1-3</Td>
          <Td>Psalms 79</Td>

          <Td>ถึงอย่างไรก็ยังมีหวัง</Td>
        </tr>
        <tr>
          <Td>197</Td>
          <Td>เอสเธอร์ 4,5</Td>
          <Td>ลูกา 11</Td>
          <Td>Esther 4,5</Td>
          <Td>Luke 11</Td>

          <Td>โอกาสที่เปิด</Td>
        </tr>
        <tr>
          <Td>198</Td>
          <Td>เอสเธอร์ 6,7</Td>
          <Td>ลูกา 12</Td>
          <Td>Esther 6,7</Td>
          <Td>Luke 12</Td>

          <Td>เรื่องราวที่คาดไม่ถึง</Td>
        </tr>
        <tr>
          <Td>199</Td>
          <Td>เอสเธอร์ 8-10</Td>
          <Td>ลูกา 13</Td>
          <Td>Esther 8-10</Td>
          <Td>Luke 13</Td>

          <Td>ให้ทุกคนรู้</Td>
        </tr>
        <tr>
          <Td>200</Td>
          <Td>โยบ 1,2</Td>
          <Td>สดุดี 80</Td>
          <Td>Job 1,2</Td>
          <Td>Psalms 80</Td>

          <Td>พระองค์ทรงอยู่ที่นั่น</Td>
        </tr>
        <tr>
          <Td>201</Td>
          <Td>โยบ 3,4</Td>
          <Td>ลูกา 14</Td>
          <Td>Job 3,4</Td>
          <Td>Luke 14</Td>

          <Td>ห้ามบ่น</Td>
        </tr>
        <tr>
          <Td>202</Td>
          <Td>โยบ 5,6</Td>
          <Td>ลูกา 15</Td>
          <Td>Job 5,6</Td>
          <Td>Luke 15</Td>

          <Td>ทุกคนสำคัญสำหรับพระเจ้า</Td>
        </tr>
        <tr>
          <Td>203</Td>
          <Td>โยบ 7,8</Td>
          <Td>สดุดี 81,82</Td>
          <Td>Job 7,8</Td>
          <Td>Psalms 81,82</Td>

          <Td>ความช่วยเหลือถึงผู้สิ้นหวัง</Td>
        </tr>
        <tr>
          <Td>204</Td>
          <Td>โยบ 9,10</Td>
          <Td>ลูกา 16</Td>
          <Td>Job 9,10</Td>
          <Td>Luke 16</Td>

          <Td>เมื่อประสบทุกข์หนัก</Td>
        </tr>
        <tr>
          <Td>205</Td>
          <Td>โยบ 11,12</Td>
          <Td>ลูกา 17</Td>
          <Td>Job 11,12</Td>
          <Td>Luke 17</Td>

          <Td>ยื่นมือช่วยเหลือ</Td>
        </tr>
        <tr>
          <Td>206</Td>
          <Td>โยบ 13,14</Td>
          <Td>ลูกา 18</Td>
          <Td>Job 13,14</Td>
          <Td>Luke 18</Td>

          <Td>แสวงหาคำตอบ</Td>
        </tr>
        <tr>
          <Td>207</Td>
          <Td>โยบ 15-17</Td>
          <Td>สดุดี 83,84</Td>
          <Td>Job 15-17</Td>
          <Td>Psalms 83,84</Td>

          <Td>ช่วงวิกฤติ</Td>
        </tr>
        <tr>
          <Td>208</Td>
          <Td>โยบ 18,19</Td>
          <Td>ลูกา 19</Td>
          <Td>Job 18,19</Td>
          <Td>Luke 19</Td>

          <Td>ตั้งใจฟังให้ดี</Td>
        </tr>
        <tr>
          <Td>209</Td>
          <Td>โยบ 20,21</Td>
          <Td>ลูกา 20</Td>
          <Td>Job 20,21</Td>
          <Td>Luke 20</Td>

          <Td>โอกาสที่จะพูด</Td>
        </tr>
        <tr>
          <Td>210</Td>
          <Td>โยบ 22,23</Td>
          <Td>สดุดี 85</Td>
          <Td>Job 22,23</Td>
          <Td>Psalms 85</Td>

          <Td>สันติสุขในพระเจ้า</Td>
        </tr>
        <tr>
          <Td>211</Td>
          <Td>โยบ 24-26</Td>
          <Td>ลูกา 21</Td>
          <Td>Job 24-26</Td>
          <Td>Luke 21</Td>

          <Td>ชัดเจนแจ่มแจ้ง</Td>
        </tr>
        <tr>
          <Td>212</Td>
          <Td>โยบ 27,28</Td>
          <Td>ลูกา 22</Td>
          <Td>Job 27,28</Td>
          <Td>Luke 22</Td>

          <Td>อย่ายอมแพ้เด็ดขาด</Td>
        </tr>
        <tr>
          <Td>213</Td>
          <Td>โยบ 29,30</Td>
          <Td>ลูกา 23</Td>
          <Td>Job 29,30</Td>
          <Td>Luke 23</Td>

          <Td>ในช่วงทดสอบ</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default OneEightFourToTwoOneThree;
